import 'moment/locale/ko'
import util from "@/mixins/util";

export default {
    date() {
        return {}
    },
    computed: {},
    methods: {
        returnDate(data) {
            this.$moment.locale('ko')
            return this.$moment(data).startOf('second').fromNow();
        },
        returnDateFormat(date, format = 'YYYY-MM-DD') {
            this.$moment.locale('ko')
            return this.$moment(date).format(format);
        },
        returnDateTimeFormat(date, format = 'YYYY-MM-DD HH:mm') {
            if(!util.isEmpty(date)){
                this.$moment.locale('ko')
                return this.$moment(date).format(format);
            }else{
                return ''
            }
        },
        returnWeekday(data) {
            let week = ['일', '월', '화', '수', '목', '금', '토']
            let day = this.$moment(data).day()
            return `${week[day]}요일`
        },
        returnToday(format = 'YYYY-MM-DD') {
            return this.$moment().format(format);
        },
        returnSecondTime(data) {
            let today = this.$moment();
            let diffDate = today.diff(data, 'seconds');
            if (diffDate < 60 && diffDate > 0) {
                return diffDate + '초 전'
            } else if (diffDate <= 0) {
                return '1초 전'
            } else if (diffDate > 60 && diffDate <= 3600) {
                return `${parseInt(diffDate / 60)}분 전`
            } else if (diffDate > 3600 && diffDate <= 86400) {
                let min = parseInt(diffDate / 60)
                return `${parseInt(min / 60)}시간 전`;
            } else {
                return this.returnDate(data);
            }
        },
        returnOneDayDate(data) {
            let today = this.$moment();
            let diffDate = today.diff(data, 'seconds');
            if (diffDate < 60 && diffDate > 0) {
                return diffDate + '초 전'
            } else if (diffDate <= 0) {
                return '1초 전'
            } else if (diffDate > 60 && diffDate <= 3600) {
                return `${parseInt(diffDate / 60)}분 전`
            } else if (diffDate > 3600 && diffDate < 86400) {
                let min = parseInt(diffDate / 60)
                return `${parseInt(min / 60)}시간 전`;
            } else if (diffDate <= 86400) {
                return this.returnDate(data);
            } else {
                return this.$moment(data).format('YYYY-MM-DD hh:mm')
            }
        },
        returnDateUnix(date, format = 'YYYY-MM-DD HH:mm') {
            if (!date) {
                return '';
            }
            return this.$moment.unix(date).locale('ko').format(format)
        },
        getDifferenceTime(date) {
            if (util.isEmpty(date)) {
                return false
            }
            let current = this.$moment(date).add(30, 'd')
            let end = this.$moment()
            let diff = current.diff(end, 'second')
            if (diff > 0) {
                return true
            } else {
                return false
            }
        },
        getDifference(date) {
            if (util.isEmpty(date)) {
                return false
            }
            let current = this.$moment(date)
            let end = this.$moment()
            let diff = current.diff(end, 'days')
            return Math.abs(diff);
        },
        isDate(date) {
            console.log(this.$moment(date).isValid())
            return this.$moment(date).isValid();
        },
    }
}
